import React, { useEffect, useState, useMemo } from 'react';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../components/ui/dialog";
import { Input } from '../../components/ui/input';
import { Separator } from '../../components/ui/separator';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../components/ui/table";
import {
    Pagination,
    PaginationContent,
    PaginationItem,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
    PaginationEllipsis,
} from "../../components/ui/pagination";
import axios from 'axios';
import Chat from './Chat';
import { Button } from '../../components/ui/button';
import { Search, ShoppingCart } from 'lucide-react';
import { Toaster } from '../../components/ui/sonner';
import Cart from './Cart'

const Orders = () => {
    const token = localStorage.getItem("adminToken");
    const [bookings, setBookings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    // const getBooking = async () => {
    //   if (!token) return 
    //   const response = await axios.get(
    //     "https://wavetechservices.in/api/user/bookings",
    //     // {
    //       // headers: {
    //       //   Authorization: `Bearer ${token}`,
    //       // },
    //     // }
    //   );
    //   // console.log(response.data, "Booking");
    //   setBookings(response?.data?.data?.bookings);
    //   // console.log(responresponse.data.data.bookingsse, "ttttt");
    // };

    // Fetch bookings data
    useEffect(() => {
        const fetchBookings = async () => {
            setIsLoading(true);
            try {
                const res = await axios.get("https://wavetechservices.in/admin/bookings", {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });

                const filteredBookingss = res?.data?.data?.filter((booking)=> booking?.booking?.cart?.length > 0 )
                
                // setBookings(res.data?.data);
                const test = res?.data?.data?.filter((pro)=> pro._id ==="67e40205eac4cde096b06a16")
                console.log("test : " , test)
                // setBookings(res?.data?.data);
                setBookings(filteredBookingss);
              } catch (err) {
                console.error("Error fetching bookings:", err);
              } finally {
                setIsLoading(false);
              }
            };
            fetchBookings(); 
          }, [token]);
          
          

    // Filter bookings based on search term
    const filteredBookings = useMemo(() => {
        if (!searchTerm) return bookings;
        
        const lowercasedSearch = searchTerm.toLowerCase();
        return bookings.filter(booking => 
            booking.customerName?.toLowerCase().includes(lowercasedSearch) ||
            booking.customerPhone?.includes(searchTerm) ||
            booking.serviceName?.toLowerCase().includes(lowercasedSearch) ||
            booking.partnerName?.toLowerCase().includes(lowercasedSearch) ||
            booking.status?.toLowerCase().includes(lowercasedSearch) ||
            booking.paymentMode?.toLowerCase().includes(lowercasedSearch) ||
            booking.location?.address?.toLowerCase().includes(lowercasedSearch) ||
            booking.location?.pincode?.includes(searchTerm)
        );
    }, [bookings, searchTerm]);
 
    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    // Calculate pagination based on filtered bookings
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredBookings.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredBookings.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Reset to first page when search term changes
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    // Format address
    const formatAddress = (location) => {
        if (!location) return "N/A";
        return `${location.address || ''} ${location.landmark || ''} ${location.pincode || ''}`.trim() || "N/A";
    };

    return (
        <div className='px-[1vw] my-5'>
            <Toaster />
            <div className='flex lg:justify-between lg:items-center flex-col lg:flex-row'>
                <h1 className='text-2xl'>Orders ({filteredBookings.length})</h1>
                <div className='flex lg:gap-4 items-center gap-2 my-3 lg:my-0'>
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                        <Input 
                            placeholder='Search Orders...'
                            className="pl-10 w-full lg:w-64"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <Separator className='my-4' />

            <div className='overflow-x-auto lg:max-w-full h-[65vh]'>
                {isLoading ? (
                    <div className="flex justify-center items-center h-full">
                        <p>Loading Orders...</p>
                    </div>
                ) : (
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead className='w-[50px]'>Sl No.</TableHead>
                                <TableHead>Customer</TableHead>
                                <TableHead>Phone</TableHead>
                                {/* <TableHead className="min-w-[200px]">Address</TableHead> */}
                                <TableHead>Service</TableHead>
                                <TableHead>Price</TableHead>
                                <TableHead>Payment</TableHead>
                                <TableHead>Provider</TableHead>
                                <TableHead>Chat</TableHead>
                                <TableHead>Cart</TableHead>
                                <TableHead>Booked On</TableHead>
                                <TableHead>Status</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {currentItems.length > 0 ? (
                                currentItems.map((booking, ind) => (
                                    <TableRow key={booking._id}>
                                        <TableCell>{indexOfFirstItem + ind + 1}.</TableCell>
                                        <TableCell className="font-medium">{booking.customerName || "N/A"}</TableCell>
                                        <TableCell>{booking.customerPhone || "N/A"}</TableCell>
                                        {/* <TableCell>{formatAddress(booking.location)}</TableCell> */}
                                        <TableCell>{booking.serviceName || "N/A"}</TableCell>
                                        <TableCell>₹{booking.amount || "0"}</TableCell>
                                        <TableCell className="capitalize">{booking.paymentMode || "N/A"}</TableCell>
                                        <TableCell>{booking.partnerName || "N/A"}</TableCell>
                                        <TableCell>
                                            <Dialog>
                                                <DialogTrigger asChild>
                                                    <Button variant="ghost" size="sm">
                                                        Chat
                                                    </Button>
                                                </DialogTrigger>
                                                <DialogContent className="max-w-2xl">
                                                    <DialogHeader>
                                                        <DialogTitle>Chat with {booking.partnerName || "Service Provider"}</DialogTitle>
                                                        <DialogDescription>
                                                            <Chat booking={booking} />
                                                        </DialogDescription>
                                                    </DialogHeader>
                                                </DialogContent>
                                            </Dialog>
                                        </TableCell>
                                         
                                        <TableCell className="text-center">
                                        <Dialog>
                                          <DialogTrigger asChild>
                                            <Button 
                                              variant="ghost" 
                                              size="sm"
                                              className="relative hover:bg-gray-100 transition-colors"
                                            >
                                              <div className="flex items-center gap-1">
                                                <ShoppingCart className="h-4 w-4" />
                                                {booking.booking?.cart?.length > 0 && (
                                                  <span className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-medium text-white">
                                                    {booking.booking.cart.length}
                                                  </span>
                                                )}
                                              </div>
                                            </Button>
                                          </DialogTrigger>
                                          <DialogContent className="max-w-4xl rounded-lg">
                                            <DialogHeader>
                                              <DialogTitle className="text-lg font-semibold">
                                                <div className="flex items-center gap-2">
                                                  <ShoppingCart className="h-5 w-5" />
                                                  <span>Partner's Cart ({booking.booking?.cart?.length || 0} items)</span>
                                                </div>
                                              </DialogTitle>
                                            </DialogHeader>
                                            <div className="max-h-[70vh] overflow-y-auto p-1">
                                              <Cart booking={booking} />
                                            </div> 
                                          </DialogContent>
                                        </Dialog>
                                      </TableCell>
                                        <TableCell>{new Date(booking.createdAt).toLocaleDateString()}</TableCell>
                                        <TableCell className="capitalize">
                                            <span className={`px-2 py-1 rounded-full text-xs ${
                                                booking.status === 'completed' ? 'bg-green-100 text-green-800' :
                                                booking.status === 'cancelled' ? 'bg-red-100 text-red-800' :
                                                'bg-yellow-100 text-yellow-800'
                                            }`}>
                                                {booking.status || "N/A"}
                                            </span>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={11} className="text-center py-8">
                                        {searchTerm ? "No matching Orders found" : "No Orders available"}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                )}
            </div>

            {filteredBookings.length > itemsPerPage && (
                <div className="mt-4">
                    <Pagination>
                        <PaginationContent>
                            <PaginationItem>
                                <PaginationPrevious 
                                    onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                                    disabled={currentPage === 1}
                                />
                            </PaginationItem>

                            {Array.from({ length: totalPages }).map((_, index) => {
                                const page = index + 1;
                                if (page === 1 || page === totalPages || (page >= currentPage - 1 && page <= currentPage + 1)) {
                                    return (
                                        <PaginationItem key={page}>
                                            <PaginationLink
                                                isActive={page === currentPage}
                                                onClick={() => handlePageChange(page)}
                                            >
                                                {page}
                                            </PaginationLink>
                                        </PaginationItem>
                                    );
                                }
                                return null;
                            })}

                            <PaginationItem>
                                <PaginationNext 
                                    onClick={() => handlePageChange(Math.min(totalPages, currentPage + 1))}
                                    disabled={currentPage === totalPages}
                                />
                            </PaginationItem>
                        </PaginationContent>
                    </Pagination>
                </div>
            )}
        </div>
    );
};

export default Orders;